import React from 'react'

export const Jumbotron = ({ title, children }) =>
  <div className="container-fluid py-5">
    <h1 className="display-5 fw-bold">{title}</h1>
    <p className="col-md-8 fs-4">{children}</p>
  </div>
